import { createAction, createReducer } from "@reduxjs/toolkit";
import frc from 'front-end-common';
import ArchiveAccountsService from "../Services/ArchiveAccountsService";

const { addDefaultHandlers, getDefaultState } = frc.utils.reducerTools;


export const archiveAccountsListFetch = createAction('archiveAccounts/list', (params) => ({
  payload: ArchiveAccountsService.getArchiveAccountsList(params)
}))

export const setPhaseForArchiveAccounts = createAction('archiveAccounts/setPhase', (data) => ({
  payload: ArchiveAccountsService.setPhaseForAccounts(data)
}))

export const dearchive = createAction('account/dearchive', (data) => ({
  payload: ArchiveAccountsService.dearchiveAccount(data),
}));

export const bunchDearchive = createAction('account/dearchiveAccs', (data) => ({
  payload: ArchiveAccountsService.dearchiveAccounts(data),
}));

const initialState = {
  list: getDefaultState(),
  setPhase: getDefaultState(),
  dearchive: getDefaultState(),
  dearchiveAccs: getDefaultState()
}

export default createReducer(initialState, (builder) => {
  addDefaultHandlers(builder, archiveAccountsListFetch, 'list');
  addDefaultHandlers(builder, setPhaseForArchiveAccounts, 'setPhase');
  addDefaultHandlers(builder, dearchive, 'dearchive');
  addDefaultHandlers(builder, bunchDearchive, 'dearchiveAccs');
})
